import Store from '@/store'
import { Route } from 'vue-router'

/* eslint-disable consistent-return */
export const navGuard = (to: Route, from: Route, next: any) => {
  // only add to store if change screen
  if (from.name !== to.name) {
    Store.commit('setLoadingIndicator', true)
    // Store.commit('pushHis', to)
  } 
  // else if (from.fullPath !== to.fullPath) {
  //   Store.commit('updateHis', to)
  // }
  next()
}

/* eslint-enable consistent-return */
